module.exports = "\r\n.nav-link{\r\n  background: rgb(21, 129, 218); \r\n  border-radius: 16px 0 0 16px;\r\n  color: white;\r\n  border: 1px solid white;;\r\n  width: 100px;\r\n}\r\n\r\n.nav-link:hover {\r\n  \r\n  background: #023f28;\r\n  color: white;\r\n  font-size: 1.05em;\r\n  border-color: white;\r\n}\r\n\r\n.active-view {\r\n  background: #dbe4eb ;\r\n  border: solid 2px;\r\n  color:black\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manager/manager.component.css
// module id = ./src/app/manager/manager.component.css
// module chunks = main